import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "../config/url";

export const useRegisterUser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const registerUser = async (formData) => {
    setLoading(true);
    setError(null);
    setMessage(null);
    setSuccess(false);
    setShowPopup(false);

    // Password match validation
    if (formData.password !== formData.Cpassword) {
      setError("❌ Passwords do not match");
      setShowPopup(true);
      setLoading(false);
      return;
    }

    const signupData = {
      email: formData.email,
      password: formData.password,
      fullname: formData.fullname || "",
      gender: formData.gender || "",
      country: formData.country || "",
    };

    try {
      const response = await fetch(`${URLS}/api/user/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signupData),
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || "Signup failed");
      }

      setSuccess(true);
      setMessage("✅ Signup successful! Redirecting...");
      setShowPopup(true);

      // Redirect to home page after a short delay
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (err) {
      setError(`❌ ${err.message || "An error occurred during registration"}`);
      setSuccess(false);
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    success,
    error,
    message,
    showPopup,
    setShowPopup,
    registerUser,
  };
};
